import React, { useState, useEffect, useMemo } from "react";
import Base from "../../Config/Base";
import { API_BASE_URL } from "../../Config/Config";
import Pagination from "../../Config/Pagination";
import "../../../Assets/popup.css";
import "jspdf-autotable";
import "../../Config/loading.css";
import { useNavigate } from "react-router-dom";
import { Footer } from "../footer/footer";
import { Modal, Button, Input, message } from "antd";
import "antd/dist/reset.css";

export default function Customer() {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [customerData, setCustomerData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const [userDataSession, setUserDataSession] = useState({});

  // Recharge states
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [rechargeAmount, setRechargeAmount] = useState(0);
  const [selectedOption, setSelectedOption] = useState(null);
  const [customAmount, setCustomAmount] = useState("");
  const [rechargeLoading, setRechargeLoading] = useState(false);
  const [rechargeError, setRechargeError] = useState(null);
  const [rechargeSuccess, setRechargeSuccess] = useState(false);

  useEffect(() => {
    const userDataString =
      sessionStorage.getItem("MisUserDetails") ||
      localStorage.getItem("MisUserDetails");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);
    } else {
      navigate("/");
    }
  }, [navigate]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${API_BASE_URL}MobileSVC/getCustomer?OrgId=${userDataSession.OrgId}&CustomerId=0`,
      );
      const data = await response.json();
      if (data.Status) {
        setCustomerData(data.ResultData || []);
      }
    } catch (error) {
      console.error("Error fetching customers:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (userDataSession?.OrgId) {
      fetchData();
    }
  }, [userDataSession?.OrgId]);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const filteredItems = useMemo(() => {
    const results = customerData.filter((item) =>
      item.Name?.toLowerCase().includes(searchTerm.toLowerCase()),
    );
    setCurrentPage(1);
    return results;
  }, [customerData, searchTerm]);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Recharge handlers
  const openRecharge = (customer) => {
    setSelectedCustomer(customer);
    setRechargeAmount(0);
    setSelectedOption(null);
    setCustomAmount("");
    setRechargeError(null);
    setRechargeSuccess(false);
    setIsModalOpen(true);
  };

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    if (option === "500") {
      setRechargeAmount(500);
      setCustomAmount("");
    } else if (option === "1000") {
      setRechargeAmount(1000);
      setCustomAmount("");
    } else if (option === "250") {
      setRechargeAmount(250);
      setCustomAmount("");
    } else if (option === "other") {
      setRechargeAmount(0);
    }
  };

  const handleCustomChange = (e) => {
    const val = e.target.value;
    setCustomAmount(val);
    if (selectedOption === "other") {
      setRechargeAmount(Number(val) || 0);
    }
  };

  const handleRecharge = async () => {
    if (rechargeAmount <= 0) {
      message.error("Please select or enter a valid amount");
      return;
    }

    setRechargeLoading(true);
    setRechargeError(null);

    try {
      const res = await fetch(`${API_BASE_URL}Customer/RechargeCustomer`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          orgid: userDataSession.OrgId,
          custid: selectedCustomer?.Id,
          amount: rechargeAmount,
        }),
      });

      const result = await res.json();

      if (result) {
        // adjust condition based on your actual API response
        setRechargeSuccess(true);
        message.success(`Recharged ₹${rechargeAmount} successfully!`);
        fetchData(); // refresh list
      } else {
        throw new Error(result.Message || "Recharge failed");
      }
    } catch (err) {
      console.error(err);
      setRechargeError(err.message || "Something went wrong");
      message.error(err.message || "Recharge failed");
    } finally {
      setRechargeLoading(false);
    }
  };

  return (
    <Base>
      <div className="page-header">
        <div className="d-flex justify-content-between align-items-center flex-wrap">
          <div className="page-title me-3">
            <h4>Customer</h4>
            <h6>Manage your Customer</h6>
          </div>
          <div className="search-bar mb-3">
            <div className="input-group">
              <Input
                placeholder="Search customers..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                allowClear
              />
            </div>
          </div>
        </div>
      </div>

      <div className="card-container mb-3" style={{ marginTop: "-20px" }}>
        {loading ? (
          <div className="text-center my-5">
            <div className="containers m-auto d-flex justify-content-center align-items-center">
              <div className="dot bg-primary"></div>
              <div className="dot bg-secondary"></div>
              <div className="dot bg-success"></div>
              <div className="dot bg-danger"></div>
              <div className="dot bg-warning"></div>
              <div className="dot bg-info"></div>
            </div>
            <p>Loading...</p>
          </div>
        ) : (
          <div className="row g-3">
            {currentItems.map((item, index) => (
              <div key={index} className="col-12 col-md-6">
                <div
                  className="store-card card shadow-sm "
                  style={{
                    border: "1px solid #eee",
                    borderRadius: "10px",
                    overflow: "hidden",
                  }}
                >
                  <div className="card-body  pt-3 px-3">
                    {/* Top row: Name full width + clickable balance on right */}
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h5
                        className="card-title mb-0"
                        style={{
                          color: "#007bff",
                          fontSize: "1.25rem",
                          fontWeight: "600",
                        }}
                      >
                        {item.Name}
                      </h5>

                      {/* Clickable balance area */}

                      {userDataSession?.OrgType === 12 && (
                        <div
                          className="text-end cursor-pointer"
                          onClick={() => openRecharge(item)}
                          role="button"
                          tabIndex={0}
                          style={{
                            transition: "all 0.2s ease",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.transform = "scale(1.05)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = "scale(1)";
                          }}
                        >
                          <div className="fw-bold text-success fs-5 d-flex align-items-center justify-content-end">
                            <button className="btn btn-sm btn-outline-success mb-1 me-2">
                              Pay
                            </button>{" "}
                            <i
                              className="fas fa-indian-rupee-sign me-1"
                              style={{ fontSize: "0.95rem" }}
                            ></i>
                            {item.Balance || "0.00"}
                          </div>
                          <small
                            className="text-muted d-none"
                            style={{ fontSize: "0.75rem" }}
                          >
                            Recharge
                          </small>
                        </div>
                      )}
                    </div>

                    {/* Email left | Phone right – bottom row */}
                    <div className="d-flex justify-content-between align-items-center text-muted">
                      {/* Email – left aligned */}
                      <span className="d-flex align-items-center">
                        <i
                          className="fa-solid fa-envelope me-2"
                          style={{ color: "#007bff", fontSize: "0.9rem" }}
                        ></i>
                        <span className="">{item.Email || "N/A"}</span>
                      </span>

                      {/* Phone – right aligned */}
                      <span className="d-flex align-items-center">
                        <i
                          className="fa-solid fa-phone me-2"
                          style={{ color: "#007bff", fontSize: "0.9rem" }}
                        ></i>
                        <span className=" text-end">
                          {item.Mobile || "N/A"}
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        <Pagination
          itemsPerPage={itemsPerPage}
          totalItems={filteredItems.length}
          paginate={paginate}
          currentPage={currentPage}
        />
      </div>

      <br />
      <br />
      <br />
      <Footer />

      {/* Ant Design Modal with Tick button on top-right */}
      <Modal
        title={`Recharge - ${selectedCustomer?.Name || ""}`}
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        centered
        width={400}
        maskClosable={false}
        // Extra content in header (top-right tick button)
        extra={
          rechargeSuccess ? null : (
            <Button
              type="primary"
              shape="circle"
              icon={<span style={{ fontSize: "18px" }}>✓</span>}
              loading={rechargeLoading}
              disabled={rechargeAmount <= 0 || rechargeLoading}
              onClick={handleRecharge}
              style={{
                marginRight: 8,
                backgroundColor: "#52c41a", // green success color
                borderColor: "#52c41a",
              }}
            />
          )
        }
      >
        {rechargeSuccess ? (
          <div className="text-center py-4">
            <div className="text-success fs-4 mb-3">✓ Success</div>
            <p>Recharged ₹{rechargeAmount.toLocaleString("en-IN")}</p>
            <Button type="primary" onClick={() => setIsModalOpen(false)}>
              Done
            </Button>
          </div>
        ) : (
          <div className="d-flex flex-column gap-3 pt-2">
            {rechargeError && (
              <div className="alert alert-danger">{rechargeError}</div>
            )}

        <div className="d-flex flex-column gap-3 pt-2">
  {/* Amount buttons in one horizontal row */}
  <div className="row g-2">
    <div className="col-4">
      <Button
        type={selectedOption === "250" ? "primary" : "default"}
        onClick={() => handleOptionClick("250")}
        block
      >
        ₹250
      </Button>
    </div>
    <div className="col-4">
      <Button
        type={selectedOption === "500" ? "primary" : "default"}
        onClick={() => handleOptionClick("500")}
        block
      >
        ₹500
      </Button>
    </div>
    <div className="col-4">
      <Button
        type={selectedOption === "1000" ? "primary" : "default"}
        onClick={() => handleOptionClick("1000")}
        block
      >
        ₹1000
      </Button>
    </div>
  </div>

  {/* "Other" + input side-by-side when selected */}
  <div className="d-flex align-items-center gap-3 flex-wrap">
    {/* "Other" button – small width */}
    <Button
      type={selectedOption === "other" ? "primary" : "default"}
      onClick={() => handleOptionClick("other")}
      style={{ minWidth: "90px", width: "auto" }}  // small & fixed-ish size
    >
      Other
    </Button>

    {/* Input appears only when "Other" clicked – inline to the right */}
    {selectedOption === "other" && (
      <Input
        type="number"
        placeholder="Enter amount"
        value={customAmount}
        onChange={handleCustomChange}
        onWheel={(e) => e.target.blur()}
        min={1}
        addonBefore="₹"
        style={{
          width: "180px",           // fixed reasonable width
          flex: "1 1 auto",         // grow if space, but not too much
          minWidth: "140px",
          maxWidth: "220px",
        }}
      />
    )}
  </div>

  {/* Amount display + action buttons */}
  <div className="d-flex justify-content-between align-items-center mt-3">
    <div className="fw-bold">
      Amount: ₹{rechargeAmount.toLocaleString("en-IN")}
    </div>

    <div className="d-flex gap-2">
      <Button
        onClick={() => setIsModalOpen(false)}
        disabled={rechargeLoading}
      >
        Cancel
      </Button>
      <Button
        type="primary"
        onClick={handleRecharge}
        loading={rechargeLoading}
        disabled={rechargeAmount <= 0 || rechargeLoading}
      >
        Ok
      </Button>
    </div>
  </div>
</div>
            {/* Amount display + action buttons */}
         
          </div>
        )}
      </Modal>
    </Base>
  );
}
